export const STATUS_PAIRED = 'paired';

export const isPaired = status => status === STATUS_PAIRED;

export const setClipLastTc = (clips, clipId, tc) => {
  const currentClips = { ...clips };

  currentClips[clipId] = { ...(currentClips[clipId] || {}), clipid: Number(clipId), lasttcseen: tc };

  return currentClips;
};

export { getUserContractModel, getCurrentSubscriptions } from './customer/default/pairing.utils';
